import { useTranslation } from 'react-i18next';
import CircularLoader from '../../../../../components/CircularLoader/CircularLoader';
import UserGroupInforCard from '../../../User/UserGroupInforCard';
import Styles from '../GroupInfoModal.module.css';
import AddGroupUsersStyles from '../../AddGroupUsersModal/AddGroupUsersMoal.module.css';

const UserSearchResult = ({
  loading,
  isChecked,
  adminControl,
  setIsChecked,
  cardListRef1,
  searchResults,
  circularLoader,
  setSearchResults,
  handleRemoveUser,
  setSelectedUserId,
  handleCheckboxChange,
}) => {
  const { t } = useTranslation();
  return (
    <div className={Styles.cardList} ref={cardListRef1} style={{ height: '312px' }}>
      {searchResults && searchResults.length > 0
        ? searchResults?.map(item => (
            <UserGroupInforCard
              key={item._id}
              loading={false}
              duration={1000}
              role={item.role}
              handleRemoveUser={handleRemoveUser}
              name={item.name}
              id={item._id}
              status={item.status}
              email={item.email}
              adminControl={adminControl}
              isChecked={isChecked}
              setIsChecked={setIsChecked}
              searchResults={searchResults}
              setSearchResults={setSearchResults}
              handleCheckboxToggle={handleCheckboxChange}
              onClick={() => {
                setSelectedUserId(item._id);
              }}
            />
          ))
        : !loading && (
            <div className={AddGroupUsersStyles.emptyList}>
              <svg width='28' height='28' viewBox='0 0 24 24' fill='none' stroke='#cbd5e1' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'>
                <path d='M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2' />
                <circle cx='9' cy='7' r='4' />
              </svg>
              <span>{t('screens.chat.noUsersFound')}</span>
            </div>
          )}
      {searchResults && searchResults.length > 0 && circularLoader && (
        <div className={Styles.circularLoader}>
          <CircularLoader />
        </div>
      )}
    </div>
  );
};

export default UserSearchResult;
